export const layoutTexts = {
  header: {
    brand: 'Flip&Go',
    brandSuffix: 'Espace partenaire',
    logout: 'Se déconnecter',
  },
}
